export const ItemTypes = {
  SENSOR_LOCATION: 'sensor-location',
};
